<template>
  <div class="contact">
    <h1>Kontakt</h1>
    <p>
      Vielen Dank, dass Sie sich für meine Fotografie interessieren! Wenn Sie an einem meiner Bilder interessiert sind und es erwerben möchten, senden Sie bitte eine E-Mail an
      <a href="mailto:hardt.jim@gmail.com" class="email-link">hardt.jim@gmail.com</a>.
    </p>
    <p>
      Klicken Sie in der Galerie auf das gewünschte Bild, um es zu vergrößern. Die Foto-Nummer finden Sie unten mittig unter dem vergrößerten Bild. Geben Sie diese Nummer in Ihrer E-Mail an. 
    </p>
    <p>
      Ich werde mich schnellstmöglich mit Ihnen in Verbindung setzen, um alle Details zu besprechen.
    </p>
    <p>
      Ich freue mich auf Ihre Anfrage und darauf, Ihnen ein Stück meiner Kunst näherzubringen.
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.contact {
  background-color: black; /* Dunkler Hintergrund */
  color: white; /* Textfarbe */
  min-height: 20vh; /* Mindesthöhe */
  padding: 2vh 4vh; /* Innenabstand */
  font-family: "SamsungSans-Regular", sans-serif; /* Schriftart */
  text-align: center; /* Zentrierter Text */
}

h1 {
  font-size: 3vh;
  margin-bottom: 2vh;
}

p {
  font-size: 1.6vh;
  line-height: 2.8vh;
  margin-bottom: 2vh;
}

.email-link {
  color: #00aeff; /* Blaue Farbe */
  text-decoration: none; /* Kein Unterstreichen */
  font-weight: bold; /* Fettschrift */
}

.email-link:hover {
  color: #0056b3; /* Dunkleres Blau beim Hover */
  text-decoration: underline; /* Unterstreichen beim Hover */
}
</style>
